import { render, staticRenderFns } from "./Layout-main.vue?vue&type=template&id=18a2a463&scoped=true&"
import script from "./Layout-main.vue?vue&type=script&lang=js&"
export * from "./Layout-main.vue?vue&type=script&lang=js&"
import style0 from "./Layout-main.vue?vue&type=style&index=0&id=18a2a463&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a2a463",
  null
  
)

export default component.exports